import { render, staticRenderFns } from "./utils-heroes-page.vue?vue&type=template&id=2ed8ed0e&scoped=true"
import script from "./utils-heroes-page.vue?vue&type=script&lang=js"
export * from "./utils-heroes-page.vue?vue&type=script&lang=js"
import style0 from "./utils-heroes-page.vue?vue&type=style&index=0&id=2ed8ed0e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8ed0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed8ed0e')) {
      api.createRecord('2ed8ed0e', component.options)
    } else {
      api.reload('2ed8ed0e', component.options)
    }
    module.hot.accept("./utils-heroes-page.vue?vue&type=template&id=2ed8ed0e&scoped=true", function () {
      api.rerender('2ed8ed0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/muiutils/views/utils-heroes-page.vue"
export default component.exports